interface Props {
  onClick: () => void;
}

const SvgCloseModal: React.FC<Props> = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      style={{ cursor: "pointer" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10061_49308)">
        <path
          d="M11.999 2C6.47602 2 1.99902 6.477 1.99902 12C1.99902 17.523 6.47602 22 11.999 22C17.522 22 21.999 17.523 21.999 12C21.999 6.477 17.522 2 11.999 2ZM15.7795 14.7195C16.0725 15.0125 16.0725 15.487 15.7795 15.78C15.633 15.927 15.441 16 15.249 16C15.057 16 14.865 15.927 14.7185 15.7805L11.999 13.0605L9.27952 15.78C9.13302 15.927 8.94102 16 8.74902 16C8.55702 16 8.36502 15.927 8.21852 15.7805C7.92552 15.4875 7.92552 15.013 8.21852 14.72L10.9385 12L8.21902 9.2805C7.92602 8.9875 7.92602 8.513 8.21902 8.22C8.51202 7.927 8.98652 7.927 9.27952 8.22L11.999 10.9395L14.7185 8.22C15.0115 7.927 15.486 7.927 15.779 8.22C16.072 8.513 16.072 8.9875 15.779 9.2805L13.0595 12L15.7795 14.7195Z"
          fill="#E2E2E2"
        />
      </g>
      <defs>
        <clipPath id="clip0_10061_49308">
          <rect width="24" height="24" fill="white" transform="translate(-0.000976562)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgCloseModal;
